import React, { useState } from "react";
import DatePicker from "react-date-picker";
import Button from "react-bootstrap/Button";
import "./DatePicker.css";

function DatePickerComponent(props) {
  // const { start_date, start_date_update, end_date, end_date_update } = props;
  console.log(props);
  const lastWeek = (event) => {
    var today = new Date();
    var st_date = new Date().setDate(today.getDate() - 7);

    props.end_date_update(today);
    props.start_date_update(new Date(st_date));
  };

  const lastMonth = (event) => {
    var today = new Date();
    var st_date = new Date().setMonth(today.getMonth() - 1);

    props.end_date_update(today);
    props.start_date_update(new Date(st_date));
  };

  const lastYear = (event) => {
    var today = new Date();
    var st_date = new Date().setMonth(today.getMonth() - 12);

    props.end_date_update(today);
    props.start_date_update(new Date(st_date));
  };
  const lastThreeYear = (event) => {
    var today = new Date();
    var st_date = new Date().setMonth(today.getMonth() - 36);

    props.end_date_update(today);
    props.start_date_update(new Date(st_date));
  };

  return (
    <div>
      <div className="DatePickerContainer">
        <DatePicker
          className="DatePicker"
          onChange={props.start_date_update}
          value={props.start_date}
        />
        <br />
        <DatePicker
          className="DatePicker"
          onChange={props.end_date_update}
          value={props.end_date}
        />
      </div>
      <div>
        <Button
          variant="outline-primary"
          className="DateRangeButtons"
          onClick={lastWeek}
        >
          {" "}
          Last Week
        </Button>
        <Button
          variant="outline-primary"
          className="DateRangeButtons"
          onClick={lastMonth}
        >
          {" "}
          Last Month
        </Button>
        <Button
          variant="outline-primary"
          className="DateRangeButtons"
          onClick={lastYear}
        >
          {" "}
          Last Year
        </Button>
        <Button
          variant="outline-primary"
          className="DateRangeButtons"
          onClick={lastThreeYear}
        >
          {" "}
          Last 3 Years
        </Button>
      </div>
    </div>
  );
}

export default DatePickerComponent;
